import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M29.91,15.72H27.7a3.49,3.49,0,0,0-3.41-2.84h-5.9A3.5,3.5,0,0,0,15,15.72H12.76V17H15a3.49,3.49,0,0,0,3.42,2.83h5.9A3.48,3.48,0,0,0,27.7,17h2.21Zm-5.62,2.83h-5.9A2.19,2.19,0,0,1,16.31,17h2v-1.3h-2a2.18,2.18,0,0,1,2.08-1.53h5.9a2.17,2.17,0,0,1,2.07,1.53h-2V17h2A2.19,2.19,0,0,1,24.29,18.55Z' }),
  React.createElement('polygon', { points: '20.69 24.97 2.74 24.97 2.74 7.03 20.69 7.03 20.69 11.21 21.99 11.21 21.99 5.73 1.44 5.73 1.44 26.27 21.99 26.27 21.99 21.38 20.69 21.38 20.69 24.97' }),
  React.createElement('g', { id: 'Artboard-32' })
));